<template>
	<div>
		<div class="head">
			<el-row>
				<el-button @click="dialogFormVisible = true;form.id=''" type="primary" icon="el-icon-circle-plus-outline">添加</el-button>
			</el-row>
		</div>
		<el-table ref="multipleTable" :data="linkList" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="id" label="ID" width="50">
			</el-table-column>
			<el-table-column prop="title" label="标题" show-overflow-tooltip>
			</el-table-column>
			<el-table-column label="封面">
				<template slot-scope="scope">
					<el-image style="width: 80px; height: 80px" :src="scope.row.img"></el-image>
				</template>
			</el-table-column>
			<el-table-column prop="create_time" :formatter="$f.timeFormat" label="创建时间" show-overflow-tooltip>
			</el-table-column>
			<el-table-column prop="state" label="状态" show-overflow-tooltip>
			</el-table-column>
			<el-table-column label="管理" width="200">
				<template slot-scope="scope">
					<el-button @click="linkEdit(scope.row)">编辑</el-button>
					<el-popconfirm style="margin-left: 5px;" confirmButtonText='确定' cancelButtonText='取消' @confirm="linkDel(scope.row.id,scope.$index)"
					 icon="el-icon-info" iconColor="red" title="确定删除？">
						<el-button slot="reference" type="danger">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!-- 添加轮播弹窗 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" @close="closeDialog">
			<el-form :model="form" ref="form">
				<el-form-item label="标题" prop="title">
					<el-input v-model="form.title" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="URL" prop="url">
					<el-input v-model="form.url" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="封面">
					<el-upload ref="uUpload" class="avatar-uploader" :headers="headers" :action="action" :on-success="uploadSuccess">
						<img v-if="form.img" :src="form.img" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				action: this.$H.domain + "common/uploadFile",
				linkList: [],
				headers: {
					token: this.$store.state.userInfo.token
				},
				multipleSelection: [],
				btnLoading: false,
				btnDisabled: false,
				dialogFormVisible: false,
				dialogTitle: "",
				form: {
					id:"",
					type: 1,
					title: "",
					url: "",
					img: ""
				}
			}
		},
		watch: {
		    '$route' (to, from) {
				this.form.type = this.$route.params.type;
		        this.getLinkList();
				if (this.form.type == 1) {
					this.dialogTitle = "添加轮播图";
				}
				if (this.form.type == 2) {
					this.dialogTitle = "添加导航";
				}
				if (this.form.type == 3) {
					this.dialogTitle = "添加首页轮播图";
				}
		    }
		},
		created(options) {
			this.getLinkList();
		},
		methods: {
			submit() {
				this.btnLoading = true;
				this.btnDisabled = true;
				this.$H.post("link/save", this.form).then(res => {
					if (res.code === 200) {
						this.$refs.form.resetFields();
						this.form.introduce = "";
						this.form.img = "";
						this.goodsClassName = "";
						this.$refs.uUpload.clearFiles();
						this.$message.success(res.msg)
						this.getLinkList();
						this.dialogFormVisible = false;
					}
					if (this.form.hasOwnProperty("id")) {
						delete this.form.id;
					}

					this.btnLoading = false;
					this.btnDisabled = false;
				})
			},
			linkDel(id, index) {
				this.btnLoading = true;
				this.btnDisabled = true;
				this.$H.post("link/del", {
					id: id
				}).then(res => {
					if (res.code == 200) {
						this.linkList.splice(index, 1);
						this.$message.success(res.msg);
					}

					this.btnLoading = false;
					this.btnDisabled = false;
				})
			},
			uploadSuccess(e) {
				this.form.img = e.result.url;
			},
			getLinkList() {
				this.$H.post("link/list", {
					type: this.form.type
				}).then(res => {
					console.log(res.result.data);
					this.linkList = res.result.data;
				})
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			linkEdit(data){
				this.dialogFormVisible = true,
				this.form.type = data.type;
				this.form.url = data.url;
				this.form.img = data.img;
				this.form.title = data.title;
				this.form.id = data.id;
			},
			closeDialog() {
				if (this.form.hasOwnProperty("id")) {
					delete this.form.cate_id;
				}
				this.form.url ='';
				this.form.img ='';
				this.form.title = '';
			}
		}
	}
</script>

<style>
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>